// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointAllowedDimensionsFromJSON, DatapointAllowedDimensionsToJSON, EntityTypeFromJSON, EntityTypeToJSON, } from './';
export function DatapointAllowedDimensionsResponseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : EntityTypeFromJSON(json['id']),
        'datapointAllowedDimensions': !exists(json, 'datapointAllowedDimensions') ? undefined : json['datapointAllowedDimensions'].map(DatapointAllowedDimensionsFromJSON),
    };
}
export function DatapointAllowedDimensionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': EntityTypeToJSON(value.id),
        'datapointAllowedDimensions': value.datapointAllowedDimensions === undefined ? undefined : value.datapointAllowedDimensions.map(DatapointAllowedDimensionsToJSON),
    };
}
